import { render, staticRenderFns } from "./ProfilePhotosForms.vue?vue&type=template&id=4ef4dbb2&"
import script from "./ProfilePhotosForms.vue?vue&type=script&lang=js&"
export * from "./ProfilePhotosForms.vue?vue&type=script&lang=js&"
import style0 from "./ProfilePhotosForms.vue?vue&type=style&index=0&id=4ef4dbb2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports